module.exports = __webpack_public_path__ + "static/pdf_screenshot.85f5c628.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf_screenshot.png
// module id = 3170
// module chunks = 31740773553394